import React, { useState, useEffect } from "react";
import Header from "../Components/Header/Header.js";
import Footer from "../Components/Footer/Footer";
import Hero from "../Components/Hero";
import axios from "axios";
import { Helmet } from "react-helmet-async";

import AnnaDaan from "../Components/AnnaDaan";
import AccountDetails from "../Components/AccountDetails";
import thaliImg from "../assets/AnadaanThali.webp";
import AdoptCow from "../assets/AdoptCow.webp";
import janmashtamiBanner from "../assets/JanmasthmiBanner.jpeg";

const JanmashtmiSeva = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [donations, setDonations] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [form, setForm] = useState({
    name: "",
    phone: "",
    email: "",
    address: "",
  });

  const [loading, setLoading] = useState(false);
  const [customAmount, setCustomAmount] = useState("");
  const [errors, setErrors] = useState({});

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;
    document.body.appendChild(script);
    return () => {
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    if (name === "phone" && !/^\d*$/.test(value)) return;
    if (name === "phone" && value.length > 10) return;
    setForm({ ...form, [name]: value });
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleContinueToPay = async () => {
    const newErrors = {};
    if (!form.name.trim()) newErrors.name = "Name is required.";
    if (!form.phone) newErrors.phone = "Phone number is required.";
    else if (form.phone.length !== 10)
      newErrors.phone = "Enter a valid 10-digit phone number.";
    if (!form.email.trim()) newErrors.email = "Email is required.";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email))
      newErrors.email = "Enter a valid email address.";
    if (!form.address.trim()) newErrors.address = "Address is required.";
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    try {
      setLoading(true);
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/payment/create-order`,
        { amount: totalAmount, currency: "INR" },
      );

      const order = res.data;

      const options = {
        key: process.env.REACT_APP_RAZORPAY_KEY_ID,
        amount: totalAmount * 100,
        currency: "INR",
        name: "ISKCON Vijayawada Janmashtami Seva",
        description: donations.map((d) => d.label).join(", "),
        order_id: order.id,

        handler: async function (response) {
          try {
            const verifyRes = await axios.post(
              `${process.env.REACT_APP_API_URL}/api/payment/verify-payment`,
              {
                razorpay_order_id: response.razorpay_order_id,
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_signature: response.razorpay_signature,
                donationDetails: {
                  amount: totalAmount,
                  donor: form,
                  items: donations.map((d) => ({
                    label: d.label,
                    price: d.price,
                  })),
                },
              },
            );

            if (verifyRes.data.success) {
              await storeFormData("Success", response);
              alert("Payment successful! Thank you for your donation.");
              setShowModal(false);
            }
          } catch (err) {
            console.error(err);
            await storeFormData("Payment Failed", response);
            alert("Payment verification failed. Please contact support.");
          }
        },
        prefill: {
          name: form.name,
          email: form.email,
          contact: `+91${form.phone}`,
        },
        theme: { color: "#C61D21" },
      };

      const rzp = new window.Razorpay(options);
      rzp.open();
      rzp.on("payment.failed", async function (response) {
        alert("Payment Failed: " + response.error.description);
      });
    } catch (err) {
      alert("Something went wrong. Please try again.");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const storeFormData = async (paymentStatus, paymentResponse = {}) => {
    const storingFormData = {
      PaymentStatus: paymentStatus,
      PaymentId: paymentResponse.razorpay_payment_id || "N/A",
      OrderId: paymentResponse.razorpay_order_id || "N/A",
      Name: form.name,
      Email: form.email,
      Number: form.phone,
      Address: form.address,
      Festival: "Sri Krishna Janmashtami 2026",
      Seva: donations
        .map((d) => `${d.label} (₹${d.price.toLocaleString("en-IN")})`)
        .join("\n"),
      Items: JSON.stringify(
        donations.map((d) => ({
          seva: d.label,
          amount: d.price,
        })),
      ),
      Amount: totalAmount,
      Date: new Date().toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      }),
    };
    const formBody = new URLSearchParams(storingFormData).toString();

    try {
      await fetch(
        "https://script.google.com/macros/s/AKfycbw-78K35NrfVUzxPrA301fugLNA4U3Qe6Q0gyF7ez6DdNIUU6wmehd7-gGz_yWrQ4n0/exec",
        {
          method: "POST",
          body: formBody,
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
        },
      );
      setForm({ name: "", phone: "", email: "", address: "" });
      setDonations([]);
      setCustomAmount("");
    } catch (error) {
      console.error("Form submission error:", error);
      alert("Some error occurred while saving your donation details.");
    }
  };

  const toggleDonation = (label, price, img) => {
    setDonations((prev) =>
      prev.find((d) => d.label === label)
        ? prev.filter((d) => d.label !== label)
        : [...prev, { label, price, img }],
    );
  };

  const handleCustomDonation = () => {
    const amount = parseInt(customAmount);
    if (!amount || amount < 1) return;
    const label = "Donation As You Wish";
    setDonations((prev) => [
      ...prev.filter((d) => d.label !== label),
      { label, price: amount, img: thaliImg },
    ]);
    setCustomAmount("");
  };

  const totalAmount = donations.reduce((sum, d) => sum + d.price, 0);

  const firstLabel = donations[0]?.label || "";
  const extraCount = donations.length - 1;
  const displayLabel =
    donations.length === 0
      ? ""
      : extraCount > 0
        ? `${firstLabel} + ${extraCount} more`
        : firstLabel;

  const gauSevaOptions = [
    { label: "Gau Seva (₹5,000)", title: "Gau Seva", price: 5000 },
    { label: "Gau Seva (₹3,000)", title: "Gau Seva", price: 3000 },
    { label: "Gau Seva (₹1,000)", title: "Gau Seva", price: 1000 },
    { label: "Gau Seva (₹500)", title: "Gau Seva", price: 500 },
  ];

  return (
    <>
      <Helmet>
        <title>
          Annadanam Donation | Sri Krishna Janmashtami 2026 - ISKCON Vijayawada
        </title>
        <meta
          name="description"
          content="Donate for Annadanam during Sri Krishna Janmashtami 2026. Sponsor sanctified prasadam distribution and help feed thousands through ISKCON Vijayawada."
        />
        <meta
          name="keywords"
          content="ISKCON Vijayawada Janmashtami, Annadanam Donation, Sri Krishna Janmashtami 2026, Krishna Janmashtami Vijayawada, ISKCON Janmashtami 2026, Sponsor prasadam, feed devotees"
        />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="ISKCON Vijayawada" />
        <meta
          property="og:title"
          content="Annadanam Donation | Sri Krishna Janmashtami 2026 - ISKCON Vijayawada"
        />
        <meta
          property="og:description"
          content="Donate for Annadanam during Sri Krishna Janmashtami 2026. Sponsor sanctified prasadam distribution and help feed thousands through ISKCON Vijayawada."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://www.iskconvijayawada.org/janmastmi-seva"
        />
        <meta
          property="og:image"
          content="https://www.iskconvijayawada.org/static/media/logo.467e4780dde7b11ae4cf.png"
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Annadanam Donation | Sri Krishna Janmashtami 2026 - ISKCON Vijayawada"
        />
        <meta
          name="twitter:description"
          content="Donate for Annadanam during Sri Krishna Janmashtami 2026. Sponsor sanctified prasadam distribution and help feed thousands through ISKCON Vijayawada."
        />
        <meta
          name="twitter:image"
          content="https://www.iskconvijayawada.org/static/media/logo.467e4780dde7b11ae4cf.png"
        />

        {/* Canonical URL */}
        <link
          rel="canonical"
          href="https://www.iskconvijayawada.org/janmastmi-seva"
        />

        <script type="application/ld+json">
          {`
                {
                    "@context": "https://schema.org",
                    "@type": "Event",
                    "name": "Sri Krishna Janmashtami 2026",
                    "alternateName": "Janmashtami Celebrations ISKCON Vijayawada",
                    "startDate": "2026-08-20T04:30:00+05:30",
                    "endDate": "2026-08-21T01:00:00+05:30",
                    "eventAttendanceMode": "https://schema.org/OfflineEventAttendanceMode",
                    "eventStatus": "https://schema.org/EventScheduled",
                    "location": {
                    "@type": "Place",
                    "name": "ISKCON Vijayawada",
                    "address": {
                        "@type": "PostalAddress",
                        "streetAddress": "29-12-7, Nakkala Road, Suryaraopeta",
                        "addressLocality": "Vijayawada",
                        "addressRegion": "Andhra Pradesh",
                        "postalCode": "520002",
                        "addressCountry": "IN"
                    }
                    },
                    "image": [
                    "https://www.iskconvijayawada.org/wp-content/uploads/2024/06/janmashtami-banner.webp"
                    ],
                    "description": "Join us for the grand Sri Krishna Janmashtami 2026 celebrations at ISKCON Vijayawada. Experience continuous Hari Nama kirtan, midnight Maha Abhishekam, cultural events, and massive prasadam distribution.",
                    "organizer": {
                    "@type": "Organization",
                    "name": "ISKCON Vijayawada",
                    "url": "https://www.iskconvijayawada.org"
                    },
                    "offers": {
                    "@type": "Offer",
                    "url": "https://www.iskconvijayawada.org/janmastmi-seva",
                    "price": "0",
                    "priceCurrency": "INR",
                    "availability": "https://schema.org/InStock",
                    "validFrom": "2026-06-01T00:00:00+05:30"
                    },
                    "performer": {
                    "@type": "Organization",
                    "name": "ISKCON Devotees"
                    }
                }
                `}
        </script>
      </Helmet>

      <Header />
      <Hero image={janmashtamiBanner} />
      <div className="text-center max-w-3xl mx-auto my-8">
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-red tracking-tight leading-tight">
          Janmashtami Seva &amp; Online Donations
        </h2>

        <p className="text-base sm:text-lg text-slate-700 mt-4 leading-relaxed text-center">
          Receive the divine blessings of Sri Sri Radha Shyamasundara on this
          auspicious day by supporting festival services.
        </p>
      </div>

      {/* Anna Daan Component */}
      <AnnaDaan donations={donations} toggleDonation={toggleDonation} />

      {/* Gau Seva Component */}
      <div className="md:px-12 px-6 lg:px-8 py-6 sm:py-8">
        <h2 className="text-center text-red text-2xl sm:text-3xl lg:text-4xl font-bold mb-4 sm:mb-6 pb-1">
          Gau Seva
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 xl:grid-cols-4 gap-3 sm:gap-4">
          {gauSevaOptions.map(({ label, title, price }) => {
            const added = donations.some((d) => d.label === label);
            return (
              <div
                key={label}
                className="bg-gray-100 border border-rose-700 rounded-lg p-3 sm:p-4 flex items-center justify-between gap-2.5 sm:gap-3 transition-shadow hover:shadow-sm"
              >
                <div className="flex items-center gap-2.5 sm:gap-3 min-w-0">
                  <img
                    src={AdoptCow}
                    alt="Gau Seva"
                    className="w-12 h-12 sm:w-14 sm:h-14 xl:w-16 xl:h-16 rounded-lg object-cover flex-shrink-0"
                  />
                  <div className="min-w-0">
                    <p className="text-black font-semibold text-xs sm:text-sm truncate">
                      {title}
                    </p>
                    <p className="text-black font-medium text-xs sm:text-sm mt-0.5 sm:mt-1">
                      ₹{price.toLocaleString("en-IN")}
                    </p>
                  </div>
                </div>
                <button
                  onClick={() => toggleDonation(label, price, AdoptCow)}
                  className={`text-xs sm:text-sm px-2.5 sm:px-4 py-2 rounded transition-colors whitespace-nowrap flex-shrink-0 font-medium ${
                    added
                      ? "bg-gray-400 text-white hover:bg-gray-500"
                      : "bg-red text-white hover:bg-darkred"
                  }`}
                >
                  {added ? "Remove" : "Add Donation"}
                </button>
              </div>
            );
          })}
        </div>
      </div>

      {/* Donation As You Wish */}
      <div className="md:px-12 px-6 lg:px-8 py-4 sm:py-6">
        <div className="relative rounded-2xl overflow-hidden border border-rose-700 bg-gradient-to-r from-rose-50 to-orange-50">
          {/* Decorative top strip */}
          <div className="h-1.5 w-full bg-gradient-to-r from-rose-600 to-orange-400" />
          <div className="max-md:p-2 p-4 flex flex-col sm:flex-row items-center gap-3 md:gap-6">
            {/* Icon + Text */}
            <div className="flex flex-col items-center sm:items-start sm:w-56 flex-shrink-0 text-center sm:text-left">
              <p className="text-red font-semibold md:text-xl">
                Donation As You Wish
              </p>
              <p className="text-gray-500 text-sm">Contribute any amount</p>
            </div>
            {/* Divider */}
            <div className="hidden sm:block w-px h-16 bg-rose-200" />
            {/* Input + Button */}
            <div className="flex flex-1 flex-col sm:flex-row items-stretch sm:items-center gap-3 w-full">
              <div className="flex items-center bg-white border-2 border-rose-300 focus-within:border-rose-500 rounded-xl px-3 py-2 gap-2 flex-1 transition-colors">
                <input
                  type="text"
                  inputMode="numeric"
                  value={customAmount}
                  onChange={(e) => {
                    if (/^\d*$/.test(e.target.value))
                      setCustomAmount(e.target.value);
                  }}
                  placeholder="Enter your amount"
                  className="bg-transparent flex-1 text-gray-800 placeholder-gray-400 focus:outline-none font-medium"
                />
                {customAmount && (
                  <span className="text-xs text-gray-400 whitespace-nowrap">
                    ₹ {parseInt(customAmount).toLocaleString("en-IN")}
                  </span>
                )}
              </div>
              <button
                onClick={handleCustomDonation}
                className="bg-red hover:bg-darkred text-white font-bold px-8 py-3 rounded-xl transition-colors text-sm whitespace-nowrap shadow-md"
              >
                + Add Donation
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Account Details component */}
      <AccountDetails donateLink="https://rzp.io/rzp/H3NMKYC" />

      {/* Gentle Request alert */}
      <div className="mx-4 md:mx-12 my-6 p-6 border-2 border-rose-400 shadow-md shadow-rose-100/40 rounded-lg">
        <div className="flex items-start">
          <div className="flex-1">
            <h3 className="text-lg font-semibold text-rose-600 mb-2">
              Gentle Request!
            </h3>
            <p className="text-gray-700 leading-relaxed text-sm m-0">
              While doing Paytm/UPI App Payments or Bank (NEFT/RTGS) please send
              us a screenshot along with complete address and PAN details on our
              contact details: WhatsApp{" "}
              <span className="text-blue-600 hover:text-blue-800 font-medium cursor-pointer">
                +91-9955685568{" "}
              </span>
              Email:{" "}
              <span className="text-blue-600 hover:text-blue-800 font-medium cursor-pointer">
                seva@iskconvijayawada.org{" "}
              </span>
              You may also call on the above number for other queries.
            </p>
          </div>
        </div>
      </div>

      <Footer />

      {/* Sticky Donation Bar */}
      {donations.length > 0 && (
        <div className="fixed bottom-12 md:bottom-0 left-0 right-0 z-50 bg-gray-300 text-black px-4 sm:px-8 py-3 flex items-center justify-between gap-4 shadow-2xl">
          <div className="flex flex-col min-w-0">
            <span className="text-xs text-gray-800">Donating for</span>
            <span className="text-sm font-bold underline truncate">
              {displayLabel}
            </span>
          </div>
          <div className="flex items-center gap-3 sm:gap-6 flex-shrink-0">
            <div className="text-right">
              <p className="text-xs text-gray-800">Total Amount:</p>
              <p className="text-base sm:text-lg font-bold">
                ₹{" "}
                {totalAmount.toLocaleString("en-IN", {
                  minimumFractionDigits: 2,
                })}
              </p>
            </div>
            <button
              onClick={() => setShowModal(true)}
              className="bg-red text-white font-bold px-5 sm:px-8 py-2 sm:py-3 rounded text-sm sm:text-base transition-colors whitespace-nowrap"
            >
              Pay Now
            </button>
          </div>
        </div>
      )}

      {/* Pay Now Modal */}
      {showModal && (
        <div className="fixed inset-0 z-[60] bg-black/70 flex items-center justify-center p-4">
          <div className="bg-gray-200 rounded-xl w-full max-w-3xl max-h-[90vh] overflow-y-auto p-6 relative">
            {/* Close */}
            <button
              onClick={() => setShowModal(false)}
              className="absolute top-4 right-4 hover:bg-gray-300 w-8 h-8 rounded flex items-center justify-center text-lg"
            >
              ✕
            </button>

            {/* Title */}
            <h2 className="text-2xl font-bold mb-6 flex items-center gap-2">
              <span className="w-1 h-7 bg-red inline-block rounded"></span>
              Donate with love
            </h2>

            <div className="flex flex-col md:flex-row gap-2">
              {/* Form */}
              <div className="flex-1 border bg-white rounded-xl py-4 px-4 flex flex-col gap-2">
                <p className="text-sm">
                  Please fill required fields to continue
                </p>
                <div className="flex flex-col gap-1">
                  <input
                    name="name"
                    value={form.name}
                    onChange={handleFormChange}
                    placeholder="Your Legal Name"
                    className={`bg-transparent border rounded-lg px-4 py-2.5 text-sm placeholder-gray-500 focus:outline-none ${errors.name ? "border-red" : "border-gray-600 focus:border-gray-400"}`}
                  />
                  {errors.name && (
                    <p className="text-red text-xs px-1">{errors.name}</p>
                  )}
                </div>
                <div className="flex flex-col gap-1">
                  <div
                    className={`flex items-center border rounded-lg px-4 py-2.5 gap-2 ${errors.phone ? "border-red" : "border-gray-600"}`}
                  >
                    <span className="text-lg">🇮🇳</span>
                    <span className="text-sm">+91</span>
                    <input
                      name="phone"
                      value={form.phone}
                      onChange={handleFormChange}
                      placeholder="Phone Number"
                      inputMode="numeric"
                      className="bg-transparent flex-1 text-sm placeholder-gray-500 focus:outline-none"
                    />
                  </div>
                  {errors.phone && (
                    <p className="text-red text-xs px-1">{errors.phone}</p>
                  )}
                </div>
                <div className="flex flex-col gap-1">
                  <input
                    name="email"
                    value={form.email}
                    onChange={handleFormChange}
                    placeholder="Your Email-Id"
                    className={`bg-transparent border rounded-lg px-4 py-2.5 text-sm placeholder-gray-500 focus:outline-none ${errors.email ? "border-red" : "border-gray-600 focus:border-gray-400"}`}
                  />
                  {errors.email && (
                    <p className="text-red text-xs px-1">{errors.email}</p>
                  )}
                </div>
                <div className="flex flex-col gap-1">
                  <textarea
                    name="address"
                    value={form.address}
                    onChange={handleFormChange}
                    placeholder="Your Address"
                    rows={3}
                    className={`bg-transparent border rounded-lg px-4 py-2.5 text-sm placeholder-gray-500 focus:outline-none ${errors.address ? "border-red" : "border-gray-600 focus:border-gray-400"}`}
                  />
                  {errors.address && (
                    <p className="text-red text-xs px-1">{errors.address}</p>
                  )}
                </div>
              </div>

              {/* Donation Details */}
              <div className="w-full md:w-1/2 border bg-white rounded-xl md:py-5 py-2 px-4 flex flex-col gap-3">
                <h3 className="font-bold text-base">Donation Details</h3>
                <div className="flex flex-col gap-3">
                  {donations.map((d) => (
                    <div key={d.label} className="flex items-center gap-3">
                      <img
                        src={d.img}
                        alt=""
                        className="w-12 h-12 rounded-lg object-cover flex-shrink-0"
                      />
                      <div className="">
                        <p className="font-bold text-sm m-0 max-w-[140px]">
                          {d.label.length > 16
                            ? d.label.slice(0, 16) + "..."
                            : d.label}
                        </p>
                        <p className="text-xs m-0">{d.label}</p>
                        <p className="text-red m-0 font-semibold text-xs">
                          ₹{d.price.toLocaleString()}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
                <hr className="border-gray-600" />
                <div className="flex justify-between font-bold text-base">
                  <span>Total</span>
                  <span>₹ {totalAmount.toLocaleString()}</span>
                </div>
              </div>
            </div>

            {/* Continue to Pay */}
            <div className="mt-6 flex justify-end">
              <button
                onClick={handleContinueToPay}
                disabled={loading}
                className="bg-red hover:bg-darkred text-white font-bold px-10 py-2.5 rounded-lg text-base transition-colors w-full disabled:opacity-60 disabled:cursor-not-allowed"
              >
                {loading ? "Processing..." : "Continue to Pay"}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default JanmashtmiSeva;
